<div class="w-full flex justify-center items-center">
    <fa-icon [icon]="faSpinnerThird" class="animate-spin text-7xl color-secondary"/>
</div>